//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      require: true,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
    },
    underline: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
    },
    maxLength: {
      type: Number
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Wallet/AddWallet/components/FormField.vue